export default __webpack_public_path__ + "static/media/menu.c7478057.svg";